import { Component, ViewEncapsulation, ElementRef, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModalService } from '../../../services/modal.service';



@Component({
  selector: 'popup-modal',
  templateUrl: 'popup-modal.component.html',
  styleUrls: ['popup-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PopUpModalComponent implements OnInit, OnDestroy {
  @Input() id: string;
  private element: any;
  @Output() onClose = new EventEmitter<void>();

  constructor(private modalService: ModalService, private el: ElementRef) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    document.body.appendChild(this.element);

    // close modal on background click
    this.element.addEventListener('click', el => {
      if (el.target.className === 'popup-modal') {
        this.close();
      }
    });

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);
  }

  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  // open modal
  open(): void {
    this.element.style.display = 'block';
    document.body.classList.add('popup-modal-open');
  }

  // close modal
  close(): void {
    if (this.element.style.display === 'none') {
      return;
    }
    this.element.style.display = 'none';
    document.body.classList.remove('popup-modal-open');
    this.onClose.emit();
  }
}
